import mButton from './button/index.js';
import queryNumber from './query-number/index.js';
import enumShow from './enum-show/index';
import queryEnum from './query-enum/index';
import queryDate from './query-date/index';

const components = [
  mButton,
  queryNumber,
  enumShow,
  queryEnum,
  queryDate
];

const install = function(Vue,opts = {}){
  components.forEach(component =>{
    Vue.component(component.name,component);
  })
};


if(typeof window !== "undefined" && window.Vue){
  install(window.Vue)
}


export  default {
  install,
  mButton,
  queryNumber,
  enumShow,
  queryEnum,
  queryDate
}




// WEBPACK FOOTER //
// ./src/components/index.js